import Vue from 'vue';
import Router from 'vue-router';
// 中转页面
import TransferView from '../views/compatible/transfer.view.vue';
// computer
// 公司首页
import ComputerHomePage from '../views/computer/home/computer.home.page.vue';
// 公司简介
import CompanyProfilePage from '../views/computer/company/company.profile.page.vue';
// 产品信息
import ProductInformationPage from '../views/computer/product/product.information.page.vue';
// 团队介绍
import TeamIntroductionPage from '../views/computer/team/team.introduction.page.vue';
// 合作伙伴
import PartnerPageView from '../views/computer/partner/partner.page.view.vue';
// 关于我们
import AboutUsPage from '../views/computer/about/about.us.page.vue';
// 地图
// app
// 首页
import AppHomePage from '../views/app/home/app.home.page.vue';
// 产品信息
import AppProductPage from '../views/app/product/app.product.page.vue';
// 团队合作
import AppTeamPage from '../views/app/team/app.team.page.vue';
// 合作伙伴
import AppPartnerPage from '../views/app/partner/app.partner.page.vue';
// 关于我们
import AppAboutPage from '../views/app/about/app.about.page.vue';
// 地图导航
import AppMapPage from '../views/app/about/app.map.page.vue';
Vue.use(Router);

/* 开始数据勿动
export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloView',
      component: HelloView
    }
  ]
})
*/
export default class router {
  /**
   *  设置路由
   *  key= 路由名字 value=路由详细设置
   * @returns 返回路由列表
   */
  static routeMap() {
    return {
      // 中转页面
      TransferView: {
        path: '/',
        component: TransferView
      },
      // computer
      ComputerHomePage: {
        path: '/computerHome',
        component: ComputerHomePage
      },
      CompanyProfilePage: {
        path: '/companyProfile',
        component: CompanyProfilePage
      },
      ProductInformationPage: {
        path: '/productInformation',
        component: ProductInformationPage
      },
      TeamIntroductionPage: {
        path: '/teamIntroduction',
        component: TeamIntroductionPage
      },
      PartnerPageView: {
        path: '/partnerPage',
        component: PartnerPageView
      },
      AboutUsPage: {
        path: '/aboutUs',
        component: AboutUsPage
      },
      // app
      AppHomePage: {
        path: '/appHome',
        component: AppHomePage
      },
      AppProductPage: {
        path: '/appProduct',
        component: AppProductPage
      },
      AppTeamPage: {
        path: '/appTeam',
        component: AppTeamPage
      },
      AppPartnerPage: {
        path: '/appPartner',
        component: AppPartnerPage
      },
      AppAboutPage: {
        path: '/appAbout',
        component: AppAboutPage
      },
      AppMapPage: {
        path: '/appMap',
        component: AppMapPage
      }
    };
  }

  static routes() {
    let routes = [];
    let routeMap = this.routeMap();
    for (let route in routeMap) {
      if (routeMap.hasOwnProperty('hook')) {
      }
      if (routeMap.hasOwnProperty(route)) {
        routes.push({name: route, ...routeMap[route]});
      }
    }
    return routes;
  }

  static router() {
    return new Router({
      routes: this.routes()
    });
  }
}

export const sss = 100;
